import { useState, useEffect, useCallback } from 'react';
import { useEasyModeProgress } from './useLocalStorage';
import { useTranslation } from 'react-i18next';

export const useTasks = () => {
    const { progress } = useEasyModeProgress();
    const { t } = useTranslation();
    
    const [tasks, setTasks] = useState([
        {
            id: 1,
            titleKey: "easy_mode_setup",
            reward: 50,
            icon: "⚡",
            status: "soon", // claim, start, disabled, completed, soon
            action: () => {
                // Логика для получения награды
                console.log("Claiming reward for Easy Mode");
            }
        },
        {
            id: 2,
            titleKey: "connect_wallet",
            reward: 100,
            icon: "💳",
            status: "soon", // claim, start, disabled, soon
            action: () => {
                // Логика для подключения кошелька
                console.log("Starting wallet connection");
            }
        },
        {
            id: 3,
            titleKey: "buy_nft_pass",
            reward: 1000,
            icon: "⭐",
            status: "soon", // claim, start, disabled, soon
            action: () => {
                // Логика для покупки NFT
                console.log("Starting NFT purchase");
            }
        },
        {
            id: 4,
            titleKey: "join_telegram",
            reward: 100,
            icon: "📱",
            status: "soon", // claim, start, disabled, soon
            action: () => {
                // Логика для перехода в Telegram
                window.open("https://t.me/deguard", "_blank");
            }
        },
        {
            id: 5,
            titleKey: "join_twitter",
            reward: 100,
            icon: "🐦",
            status: "soon", // claim, start, disabled, soon
            action: () => {
                // Логика для перехода в Twitter
                window.open("https://twitter.com/deguard", "_blank");
            }
        }
    ]);

    // Оставляем все задачи со статусом "soon"
    // useEffect(() => {
    //     const isCompleted = progress.completedSteps.length >= 3;
    //     setTasks(prevTasks => 
    //         prevTasks.map(task => 
    //             task.id === 1 
    //                 ? { 
    //                     ...task, 
    //                     status: isCompleted ? "claim" : "start" 
    //                 }
    //                 : task
    //         )
    //     );
    // }, [progress.completedSteps.length]);

    const handleTaskAction = useCallback((taskId) => {
        setTasks(prevTasks => {
            const task = prevTasks.find(t => t.id === taskId);
            if (task && task.action) {
                task.action();
                
                // Если задача была выполнена, обновляем её статус
                if (task.status === "claim") {
                    return prevTasks.map(t => 
                        t.id === taskId 
                            ? { ...t, status: "completed" }
                            : t
                    );
                }
            }
            return prevTasks;
        });
    }, []);

    const getTotalReward = useCallback(() => {
        return tasks.reduce((sum, task) => sum + task.reward, 0);
    }, [tasks]);

    const getAvailableTasks = useCallback(() => {
        return tasks.filter(task => task.status !== "disabled").length;
    }, [tasks]);

    const getCompletedTasks = useCallback(() => {
        return tasks.filter(task => task.status === "completed").length;
    }, [tasks]);

    return {
        tasks,
        handleTaskAction,
        getTotalReward,
        getAvailableTasks,
        getCompletedTasks
    };
}; 